module.exports = __webpack_public_path__ + "img/LB002009.4225aef2.png";